import { FC, useEffect, useState } from "react";
import styles from "./LeaderRegistration.module.css";
import Icon from "@ant-design/icons";
import { CloseIconSmall } from "../../assets/icons/CloseIconSmall";
import { Drots } from "../../assets/icons/Drots";
import { useAppDispatch, useAppSelector } from "../../store";
import { signupLeaderId } from "../../store/actions/leaderAction";
import {
  deleteCookie,
  getCookie,
  getCountryCode,
  phoneRegions,
  phoneRules,
} from "../../utils";
import { Form, Input, Select, Button } from "antd";
import MaskedInput from "antd-mask-input";
import { useNavigate } from "react-router-dom";
import { getMask } from "../../components/PhoneMask/PhoneMask";
import { AcronymEnum } from "../../types/types";
import { Errors, SetSignupLeaderIdStatus } from "../../store/slices/userSlice";

const LEADER_ACCESS_TOKEN_NAME = "_lat";

export const LeaderRegistration: FC = () => {
  const leaderAccessToken = getCookie(LEADER_ACCESS_TOKEN_NAME);

  const dispatch = useAppDispatch();
  const { _errors, isSignupLeaderId } = useAppSelector(
    ({ userSlice }) => userSlice
  );

  const [mask, setMask] = useState("(000)000-00-00");
  const [countryCode, setCountryCode] = useState("7");
  const [phone, setPhone] = useState("");
  const navigate = useNavigate();

  const onChangePhoneHandler = (e: any) => {
    if (e.type === "paste") {
      e.preventDefault();
    }

    setPhone(e.target.value);
  };

  const onChangeCountryHandler = (currentAcronym = AcronymEnum.rf) => {
    const code = (getCountryCode(currentAcronym) ?? "").slice(1);
    setMask(getMask(code));
    setCountryCode(code);
    setPhone("");
  };

  const getPhoneValue = () => {
    if (countryCode !== "mail") {
      return (
        `${countryCode === "7" ? "8" : countryCode}` +
        phone.replace(/[^+\d]/g, "")
      );
    }
  };

  const onCancelHandler = () => {
    deleteCookie(LEADER_ACCESS_TOKEN_NAME);
    navigate("/login");
  };

  const signupLeaderIdHandler = () => {
    const phoneValue = getPhoneValue();

    if (leaderAccessToken && phoneValue?.length) {
      dispatch(
        signupLeaderId({
          phone: phoneValue,
          access_token: leaderAccessToken,
        })
      );
    }
  };

  useEffect(() => {
    if (isSignupLeaderId) {
      const profileURL = process.env.REACT_APP_ONEID_BASE_URL
        ? `${process.env.REACT_APP_ONEID_BASE_URL}/registration?need_registration=true`
        : process.env.REACT_APP_UNIONE_BASE_URL;

      if (profileURL) {
        window.location.href = profileURL;
      } else {
        navigate("/login");
      }
    }

    return () => {
      dispatch(Errors([""]));
      deleteCookie(LEADER_ACCESS_TOKEN_NAME);
      dispatch(SetSignupLeaderIdStatus(false));
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSignupLeaderId]);

  return (
    <div className={styles._container}>
      <div className={styles._body}>
        <Icon
          component={CloseIconSmall}
          className={styles._close}
          onClick={onCancelHandler}
        />

        {!leaderAccessToken && (
          <div>
            <p className={styles._text}>
              Что-то пошло не так. Попробуйте авторизоваться снова
            </p>
            <Button
              disabled={phone.includes("_")}
              className={styles.sendButton}
              onClick={onCancelHandler}
              type="primary"
            >
              Вернуться к авторизации
            </Button>
          </div>
        )}

        {leaderAccessToken && !isSignupLeaderId && (
          <div>
            <h1 className={styles._title_text}>
              Введите номер <br /> телефона
            </h1>
            <p className={styles._text}>Введите ваш номер телефона</p>
            <Form.Item
              className={styles.formBlock}
              rules={phoneRules}
              hasFeedback
            >
              <Input.Group className={styles.inpGroup}>
                <Select
                  defaultValue={phoneRegions[0].acronym}
                  className={styles.groupSelect}
                  onChange={onChangeCountryHandler}
                >
                  {phoneRegions.map((item: any) => (
                    <Select.Option key={item.acronym} value={item.acronym}>
                      <img src={item.icon} alt="" width={20} />
                      {item.code}
                    </Select.Option>
                  ))}
                </Select>
                <span className={styles.line} />
                <MaskedInput
                  mask={mask}
                  size="middle"
                  allowClear
                  name="phone"
                  type="text"
                  placeholder={mask}
                  value={phone}
                  onChange={onChangePhoneHandler}
                  onFocus={onChangePhoneHandler}
                  onPressEnter={signupLeaderIdHandler}
                />

                <Icon component={Drots} className={styles.drots} />
              </Input.Group>
              {_errors.length &&
                _errors.map((error) => <p className={styles.error}>{error}</p>)}
            </Form.Item>

            <Button
              disabled={phone.includes("_")}
              className={styles.sendButton}
              onClick={signupLeaderIdHandler}
              type="primary"
            >
              Далее
            </Button>
            <Button
              className={styles.cancelButton}
              type="text"
              onClick={onCancelHandler}
            >
              Отмена
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};
